// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.suggestions-dropdown {
  background-color: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 8px;
  padding: 16px;
  margin: 8px 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.suggestions-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  color: #856404;
}

.suggestions-icon {
  font-size: 18px;
}

.suggestions-content p {
  margin: 0 0 12px 0;
  color: #495057;
  font-size: 14px;
}

.suggestions-list {
  background-color: white;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  padding: 12px;
  margin-bottom: 12px;
}

.suggestion-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 0;
  cursor: pointer;
  border-bottom: 1px solid #f8f9fa;
}

.suggestion-item:last-child {
  border-bottom: none;
}

.suggestion-item:hover {
  background-color: #f8f9fa;
  border-radius: 4px;
  margin: 0 -8px;
  padding: 8px;
}

.suggestion-item input[type="radio"] {
  margin: 0;
}

.suggestion-text {
  flex: 1 1;
  font-size: 14px;
  color: #333;
}

.suggestions-actions {
  display: flex;
  justify-content: flex-end;
}

.btn-apply-suggestion {
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 8px 16px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.btn-apply-suggestion:hover {
  background-color: #0056b3;
}

/* Rule Dialog Styles */
.rule-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.rule-dialog {
  background-color: white;
  border-radius: 8px;
  padding: 24px;
  max-width: 500px;
  width: 90%;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.rule-dialog h3 {
  margin: 0 0 16px 0;
  color: #333;
  font-size: 18px;
}

.rule-dialog p {
  margin: 0 0 20px 0;
  color: #555;
  line-height: 1.5;
}

.rule-dialog-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

.btn-create-rule {
  background-color: #28a745;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 10px 16px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.btn-create-rule:hover {
  background-color: #218838;
}

.btn-skip-rule {
  background-color: #6c757d;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 10px 16px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.btn-skip-rule:hover {
  background-color: #5a6268;
}

.btn-cancel {
  background-color: #dc3545;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 10px 16px;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.btn-cancel:hover {
  background-color: #c82333;
}

/* Responsive design */
@media (max-width: 600px) {
  .rule-dialog {
    padding: 16px;
    margin: 16px;
  }
  
  .rule-dialog-actions {
    flex-direction: column;
  }
  
  .rule-dialog-actions button {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/SuggestionsDropdown.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAO;EACP,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;IACb,YAAY;EACd;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".suggestions-dropdown {\n  background-color: #fff3cd;\n  border: 1px solid #ffeaa7;\n  border-radius: 8px;\n  padding: 16px;\n  margin: 8px 0;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.suggestions-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-bottom: 12px;\n  color: #856404;\n}\n\n.suggestions-icon {\n  font-size: 18px;\n}\n\n.suggestions-content p {\n  margin: 0 0 12px 0;\n  color: #495057;\n  font-size: 14px;\n}\n\n.suggestions-list {\n  background-color: white;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  padding: 12px;\n  margin-bottom: 12px;\n}\n\n.suggestion-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 0;\n  cursor: pointer;\n  border-bottom: 1px solid #f8f9fa;\n}\n\n.suggestion-item:last-child {\n  border-bottom: none;\n}\n\n.suggestion-item:hover {\n  background-color: #f8f9fa;\n  border-radius: 4px;\n  margin: 0 -8px;\n  padding: 8px;\n}\n\n.suggestion-item input[type=\"radio\"] {\n  margin: 0;\n}\n\n.suggestion-text {\n  flex: 1;\n  font-size: 14px;\n  color: #333;\n}\n\n.suggestions-actions {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.btn-apply-suggestion {\n  background-color: #007bff;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 8px 16px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.btn-apply-suggestion:hover {\n  background-color: #0056b3;\n}\n\n/* Rule Dialog Styles */\n.rule-dialog-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2000;\n}\n\n.rule-dialog {\n  background-color: white;\n  border-radius: 8px;\n  padding: 24px;\n  max-width: 500px;\n  width: 90%;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.rule-dialog h3 {\n  margin: 0 0 16px 0;\n  color: #333;\n  font-size: 18px;\n}\n\n.rule-dialog p {\n  margin: 0 0 20px 0;\n  color: #555;\n  line-height: 1.5;\n}\n\n.rule-dialog-actions {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n}\n\n.btn-create-rule {\n  background-color: #28a745;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 10px 16px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.btn-create-rule:hover {\n  background-color: #218838;\n}\n\n.btn-skip-rule {\n  background-color: #6c757d;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 10px 16px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.btn-skip-rule:hover {\n  background-color: #5a6268;\n}\n\n.btn-cancel {\n  background-color: #dc3545;\n  color: white;\n  border: none;\n  border-radius: 4px;\n  padding: 10px 16px;\n  font-size: 14px;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n.btn-cancel:hover {\n  background-color: #c82333;\n}\n\n/* Responsive design */\n@media (max-width: 600px) {\n  .rule-dialog {\n    padding: 16px;\n    margin: 16px;\n  }\n  \n  .rule-dialog-actions {\n    flex-direction: column;\n  }\n  \n  .rule-dialog-actions button {\n    width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
